<template>
  <div>
    <PageMain
      ref="main"
      :disabled="disabled"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      :restockStatus="restockStatus"
      :isVc="isVc"
      @reload="reload"
      @reject="reject"
      @confirm="confirmApi"
      @checkbox-change="(data) => (checkedRows = data)"
    >
      <template slot="header">
        <div class="table_toolbar">
          <div class="d-flex" style="flex:1;">
            <PageHeader
              ref="header"
              :isVc="isVc"
              @query="getData"
              @reset="resetPage"
            />

            <el-badge
              :value="checkedRowCount"
              :hidden="!checkedRowCount"
              class="clearable-button"
              :class="{ clearable: !!checkedRowCount }"
              v-if="!disabled"
            >
              <b-button
                size="sm"
                class="ml-2"
                variant="outline-success"
                @click="confirm()"
                :disabled="!checkedRowCount"
              >
                {{ $l('menu_text_confirm') || '通过' }}
                <i
                  class="el-icon-circle-close"
                  @click.stop="clearCheckboxRow"
                />
              </b-button>
            </el-badge>
          </div>

          <div>
            <SearchTabs
              v-model="restockStatus"
              :options="searchTabOpts"
              @change="editReload({ isReset: true })"
            />
          </div>
        </div>
      </template>
      <pagination
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </PageMain>
    <ReplyRejected
      :visible.sync="replyRejectedOpts.visible"
      :amzReplenishmentDetailCode="replyRejectedOpts.amzReplenishmentDetailCode"
      @reload="editReload"
    />
  </div>
</template>
<script>
import PageHeader from './header'
import PageMain from './main'
import SearchTabs from './search-tabs'
import ReplyRejected from '../reply-rejected'
import BaseTable from '@/mixins/base-table'
import { add } from '@/libs/util.number.js'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [BaseTable, EditLoading],
  components: { PageMain, PageHeader, SearchTabs, ReplyRejected },
  props: {
    disabled: { type: Boolean, default: false },
    amzReplenishmentCode: { type: String, default: '' },
    isVc: { type: String, default: '' },
  },
  data() {
    return {
      usePage: true,
      replyRejectedOpts: {
        visible: false,
        amzReplenishmentDetailCode: '',
      },
      restockStatus: '',
      noreplyCount: 0,
      normalCount: 0,
      partRestockCount: 0,
      outStockCount: 0,
      checkedRows: [],
    }
  },
  computed: {
    totalCount() {
      return add(
        add(this.normalCount, this.partRestockCount),
        this.outStockCount
      )
    },
    searchTabOpts() {
      return [
        {
          label: this.$l('btn_noreply') || '未返答',
          value: 'N',
          badge: this.noreplyCount,
        },
        {
          label: this.$l('btn_total') || '已返答',
          value: '',
          badge: this.totalCount,
        },
        {
          label: this.$l('btn_normal') || '正常补货',
          value: 'Y',
          badge: this.normalCount,
        },
        {
          label: this.$l('btn_partRestock') || '部分补货',
          value: 'P',
          badge: this.partRestockCount,
        },
        {
          label: this.$l('btn_outStock') || '缺货',
          value: 'O',
          badge: this.outStockCount,
        },
      ]
    },
    checkedRowCount() {
      return this.checkedRows?.length || 0
    },
  },
  methods: {
    editReload({ isReset = false } = {}) {
      this.reload({ isReset })
      this.clearCheckboxRow()
    },
    async getData(form) {
      if (!this.amzReplenishmentCode) return

      let params = {
        ...form,
        listRestockStatus: [this.restockStatus].filter(Boolean),
        listReplysStatus: ['S', 'Y', 'B'],
      }

      if ('N' === this.restockStatus) {
        params = {
          ...params,
          listApprovalStatus: ['Y', 'C'],
          listReplysStatus: ['N', 'B', 'NULL'],
          listRestockStatus: [],
        }
      }

      this.getTableData(params)

      this.getCount({
        ...form,
        listApprovalStatus: ['Y', 'C'],
        listReplysStatus: ['N', 'B', 'NULL'],
        listRestockStatus: [],
      }).then((count) => {
        this.noreplyCount = count
      })

      this.getCount({
        ...form,
        listRestockStatus: ['Y'],
        listReplysStatus: ['S', 'Y', 'B'],
      }).then((count) => {
        this.normalCount = count
      })
      this.getCount({
        ...form,
        listRestockStatus: ['P'],
        listReplysStatus: ['S', 'Y', 'B'],
      }).then((count) => {
        this.partRestockCount = count
      })
      this.getCount({
        ...form,
        listRestockStatus: ['O'],
        listReplysStatus: ['S', 'Y', 'B'],
      }).then((count) => {
        this.outStockCount = count
      })
    },
    getTableData(params = {}) {
      this.loading = true
      this.$api
        .ecomAmzReplenishmentDetailListApi({
          ...params,
          ...this.page,
          amzReplenishmentCode: this.amzReplenishmentCode,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
          this.$emit('reload')
        })
        .catch(() => {
          this.loading = false
        })
    },
    async getCount(params = {}) {
      const res = await this.$api
        .ecomAmzReplenishmentDetailCountApi({
          ...params,
          amzReplenishmentCode: this.amzReplenishmentCode,
        })
        .catch(() => null)
      if (!res) return 0
      return res.body || 0
    },
    reject({ amzReplenishmentDetailCode }) {
      this.replyRejectedOpts = { visible: true, amzReplenishmentDetailCode }
    },
    async confirmApi(listCode) {
      const confirm = await this.$confirm(
        this.$l('confirm_confirmReply') || '是否确认返答？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm'),
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)

      if (!confirm) return
      this.loadingOpen()
      const res = await this.$api
        .ecomAmzReplenishmentDetailReplyOutConfirmApi({ listCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_confirmFailed'))
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_confirmSuccess'),
        type: 'success',
      })
      this.editReload()
    },
    clearCheckboxRow() {
      this.checkedRows = []
      this.$refs.main.clearCheckboxRow()
    },
    confirm() {
      if (!this.checkedRowCount) {
        this.$message({
          message: this.$l('tips_confirmReply') || '请选择需要通过的补货明细',
          type: 'warning',
        })
        return
      }

      const listCode = this.checkedRows.map(
        (row) => row.amzReplenishmentDetailCode
      )
      this.confirmApi(listCode)
    },
  },
}
</script>
<style lang="scss" scoped>
.table_toolbar {
  display: flex;
  justify-content: space-between;
  .search-form {
    flex: 1;
    max-width: 900px;
  }
  .search-container {
    margin: 0 12px;
  }
}

.clearable-button {
  .el-icon-circle-close {
    display: none;
  }
}
.clearable-button.clearable:hover {
  .el-icon-circle-close {
    display: inline-block;
    z-index: 999;
  }
  .el-icon-circle-close:hover {
    transform: scale(1.2);
  }
}
</style>
